import { useMemo } from 'react';
import './elsieAiSummary.scss';
import { SlideMenu } from '../slideMenu/SlideMenu';
import { KWELLO_ICON, KwelloSvgIcon } from 'common/components/icon/KwelloSvgIcon';
import { useAppSelector } from '../../hooks/redux';
import { useResize } from '../../hooks/resize';
import { selectIsCitationsOpen } from '../../store/slices/elsie-ai.slice';
import { ElsieAiSummaryCitations } from './ElsieAISummaryCitations';
import { ElsieAISummary } from './ElsieAISummary';
import { ElsieAISummaryFooter } from './ElsieAISummaryFooter';
import { Message } from '@progress/kendo-react-conversational-ui';
import { SurveyCitation } from 'common/models/elsie-ai.model';

interface ElsieAISummaryFlyoutProps {
  messages?: Message[];
  citations?: SurveyCitation[];
  closeCitations: () => void;
  onClose: () => void;
  flyoutOpen: boolean;
  setFlyoutOpen: (arg0: boolean) => void;
  onDeleteAll: () => void;
}

export function ElsieAISummaryFlyout({
  messages,
  flyoutOpen,
  setFlyoutOpen,
  onClose,
  closeCitations,
  citations,
  onDeleteAll,
}: Readonly<ElsieAISummaryFlyoutProps>) {
  const isCitationsOpen = useAppSelector(selectIsCitationsOpen);
  const { isTabletOrMobile } = useResize();

  const onGoBack = () => {
    if (isCitationsOpen) {
      closeCitations();
    }
  };

  const flyoutWidth = useMemo(() => {
    if (isTabletOrMobile) {
      return '50vw';
    }
    return '35vw';
  }, [isTabletOrMobile]);

  return (
    <SlideMenu
      showMenu={flyoutOpen}
      setShowMenu={setFlyoutOpen}
      title={isCitationsOpen ? `Citations [${citations?.length}]` : 'ElsieAI Summary'}
      width={flyoutWidth}
      height={'100vh'}
      onClose={isCitationsOpen ? undefined : onClose}
      titleIcon={
        isCitationsOpen ? undefined : (
          <KwelloSvgIcon
            icon={KWELLO_ICON.LIGHT_BULB_ICON}
            className="elsie-ai-flyout-light-bulb"
          />
        )
      }
      onClickGoBack={isCitationsOpen ? onGoBack : undefined}
      hideClose={isCitationsOpen}
    >
      <>
        {isCitationsOpen ? (
          <ElsieAiSummaryCitations citations={citations ?? []} closeCitations={closeCitations} />
        ) : (
          <ElsieAISummary messages={messages ?? []} />
        )}

        <ElsieAISummaryFooter onClose={onClose} onDeleteAll={onDeleteAll} />
      </>
    </SlideMenu>
  );
}
